import { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import StrategyKM3_US from "components/pages/strategy/KM3_US";

interface Props {}

const StrategyKM3_USPage: NextPage<Props> = ({}) => {
  return <StrategyKM3_US />;
};
export default StrategyKM3_USPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";

  return {
    props: {
      ...(await serverSideTranslations(locale, ["strategy"])),
    },
  };
}
